module.exports = __webpack_public_path__ + "media/images/rekognition_white-47e5b39e5a8daf977def5818eb16dc75.png";